import { useModal } from "hooks"
import { IconButton, Modal } from "materia"
import { YourJourneysListConnected } from "../YourJourneysList"
import { YourJourneysStatsConnected } from "../YourJourneysStats"
import s from "./JourneysModal.module.scss"

// Impossibly big number to ensure that all journeys will be shown
export const JOURNEY_LIST_SIZE = 1000

type JourneysModalProps = { closeRoute: string }
export const JourneysModal = ({ closeRoute }: JourneysModalProps) => {
  const { onClose } = useModal(closeRoute)

  return (
    <Modal onClose={onClose} overflowAuto={false} ariaLabel="Diploma">
      <div className={s.content}>
        <IconButton
          as="button"
          className={s.closeButton}
          icon="Close"
          onClick={onClose}
          aria-label="Close"
        />

        <div className={s.content__wrapper}>
          <div className={s.content__stats}>
            <YourJourneysStatsConnected />
          </div>

          <div className={s.content__list}>
            <YourJourneysListConnected
              size={JOURNEY_LIST_SIZE}
              onJourneyChange={onClose}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}
